<template>
  <div>
    <Form
      ref="formDynamic"
      :model="formDynamic"
      :label-width="100"
      style="width: 1010px; margin-top: 20px"
    >
      <List border size="small" style="margin: 10px 0; width: 101%">
        <ListItem>
          <Col span="3">事由:</Col>
          <Col span="19">{{ shiyou }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3">期望交付日期:</Col>
          <Col span="19">{{ jiaofuData }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3">收货信息:</Col>
          <Col span="19">{{ shouhuoInfo }}</Col>
        </ListItem>
      </List>
      <!-- 表格 -->
      <Row :gutter="5" style="margin: 10px 0; width: 101%">
        <h4 style="margin: 10px 0">明细:</h4>
        <Table
          :columns="tableCols"
          :data="data2"
          :table="table"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
        >
        </Table>
      </Row>
      <h4 style="margin: 10px 0">备注:</h4>
      <Input
        style="margin-bottom: 10px"
        v-model="approvalOpinions"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 2 }"
      ></Input>
      <Row>
        <Col span="19">
          <Button
            type="primary"
            v-show="!block"
            @click="handleSubmit(2)"
            style="margin-right: 20px"
          >
            同意
          </Button>
          <Button
            type="error"
            v-show="block"
            @click="handleSubmit(2)"
            style="margin-right: 20px"
          >
            同意
          </Button>
          <Button class="btn" @click="toggleBlock"> 拒绝 </Button>
        </Col>
        <Col span="5">
          <h3 class="zong">总价:{{ zongjia }}元</h3>
        </Col>
      </Row>
      <h4 style="margin: 10px 0" v-show="block">拒绝理由:</h4>
      <Input
        style="margin-bottom: 10px"
        v-show="block"
        v-model="rejectReason"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 2 }"
      ></Input>
      <Button type="error" v-show="block" @click="handleSubmit(6)">提交</Button>
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  props: {
    item: "",
  },
  data() {
    return {
      approvalOpinions: "",
      zongjia: 0,
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      rejectReason: "",
      block: false,
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 485,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "350px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "公/本仓",
          key: "text",
          minWidth: 65,
          align: "center",
        },
        {
          title: "申请数",
          key: "alertNum",
          minWidth: 60,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "jdPrice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.jdPrice ? row.jdPrice.toFixed(2) : 0;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
      ],
      obj: {},
    };
  },
  async created() {
    let id = this.item;
    let res = await $utils.api.load(`/admin/system/procurementWork/${id}`);
    if (res.code == 200) {
      this.shiyou = res.data.becauseWork;
      if (res.data.needTime) {
        var date = res.data.needTime;
        this.jiaofuData = date.split("T")[0];
      }
      this.shouhuoInfo = res.data.receivingInformation;
      let arr = res.data.sysProcurementDetails;
      this.obj = res.data;
      let num = arr.reduce((total, item) => {
        return total + item.jdPrice * item.alertNum;
      }, 0);
      this.zongjia = num.toFixed(2);
      for (let i = 0; i < arr.length; i++) {
        let consumableIn = {};
        consumableIn.consumableNum = arr[i].consumableNum;
        consumableIn.consumableImgUrl = arr[i].consumableImgUrl;
        consumableIn.brand = arr[i].brand;
        consumableIn.name = arr[i].name;
        consumableIn.model = arr[i].model;
        consumableIn.remark = arr[i].remark;
        consumableIn.num = arr[i].num;
        consumableIn.unit = arr[i].unit;
        consumableIn.alertNum = arr[i].alertNum;
        consumableIn.unitPrice = arr[i].unitPrice;
        consumableIn.jdPrice = arr[i].jdPrice;
        let ownNum = arr[i].ownNum == null ? 0 : arr[i].ownNum;
        let adminNum = arr[i].adminNum == null ? 0 : arr[i].adminNum;
        consumableIn.text = adminNum + "/" + ownNum;
        this.data2.push(consumableIn);
      }
    }
  },
  methods: {
    toggleBlock() {
      this.block = true;
    },
    async handleSubmit(num) {
      let q = this.obj;
      q.state = num;
      q.rejectReason = this.rejectReason;
      q.approvalOpinions = this.approvalOpinions;
      let res = await $utils.api.load("/admin/system/procurementWork/edit", q, "post");
      if (res.code == 200) {
        if (num == 2) {
          await $utils.toast.success("审核成功");
          this.$Modal.remove();
          setTimeout(function () {
            $utils.url.go(0);
          }, 1000);
        } else if (num == 6) {
          await $utils.toast.success("保存成功");
          this.$Modal.remove();
          setTimeout(function () {
            $utils.url.go(0);
          }, 1000);
        }
      }
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 14px;
  color: #515a6e;
}
.btn {
  color: white !important;
  background-color: #ff4646 !important;
  border-color: #ff4646 !important;
}
.btn:hover {
  color: white !important;
  background-color: #ff4646 !important;
  border-color: #ff4646 !important;
}
</style>
